import { request, gql } from 'graphql-request';

import { getConfig } from '@app/config';
import { Pool } from '@app/types/pool';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { OLD_WEETH_TOKEN } from '@app/constants/tokens';
import { useChainId } from '@thirdweb-dev/react';
import { Mode } from '@thirdweb-dev/chains';

type Variables = {
  poolId: string;
};

function getQuery() {
  return gql`
    query SinglePool($poolId: ID!) {
      pool(id: $poolId) {
        id
        fee
        token0 {
          id
          symbol
          name
          decimals
          derivedMatic
        }
        token1 {
          id
          symbol
          name
          decimals
          derivedMatic
        }
        sqrtPrice
        liquidity
        tick
        tickSpacing
        totalValueLockedUSD
        volumeUSD
        feesUSD
        untrackedFeesUSD
        token0Price
        token1Price
      }
    }
  `;
}

export const fetcher = async (poolId: string, chainId: number | undefined) => {
  const query = getQuery();

  return await request<{ pool: Pool }>(
    `${getConfig(chainId ?? Mode.chainId)?.URLS.subgraphUrlV3}`,
    query,
    {
      poolId: poolId.toLowerCase()
    }
  );
};

export const useSinglePoolQuery = (
  params: Variables,
  options: UseQueryOptions<Pool | undefined> = {}
) => {
  const chainId = useChainId();

  return useQuery<Pool | undefined>(
    [QueryKeys.SINGLE_POOL, { params, chainId }],
    async () => {
      const res = await fetcher(params.poolId, chainId);

      if (!res) {
        return;
      }

      const isOldWeETHToken0 =
        res.pool.token0.id.toLowerCase() === OLD_WEETH_TOKEN;
      const isOldWeETHToken1 =
        res.pool.token1.id.toLowerCase() === OLD_WEETH_TOKEN;

      return {
        ...res.pool,
        token0: isOldWeETHToken0
          ? {
              ...res.pool.token0,
              symbol: '(OLD) weETH'
            }
          : res.pool.token0,
        token1: isOldWeETHToken1
          ? {
              ...res.pool.token1,
              symbol: '(OLD) weETH'
            }
          : res.pool.token1
      };
    },
    {
      ...options
      // enabled: Boolean(chainId)
    }
  );
};
